import CloseIcon from "@mui/icons-material/Close";
import { Box, Drawer, Grid, IconButton, Typography } from "@mui/material";
import { debounce } from "lodash";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import DefaultApiService from "../../../infrastructure/api/default";
import { ReactComponent as ClockIcon } from "../../assets/icons/clock.svg";
import LoadingWrapper from "../shared/loading";
import HistoryItem from "./HistoryItem";

const HistoryDrawer = () => {
  const [loading, setLoading] = useState([]);
  const [historyList, setHistoryList] = useState([]);
  const [isOpenDrawer, setIsOpenDrawer] = useState(false);

  const onGetHistoryList = debounce(() => {
    setLoading(true);
    DefaultApiService.getListApi("UM/UpdateHistory")
      .then((res) => {
        setLoading(false);
        console.log("res", res);
        if (res.data.length) {
          setHistoryList(res.data);
        } else {
          setHistoryList([]);
        }
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err?.message || "خطایی رخ داده است");
      });
  }, 500);

  useEffect(() => {
    if (isOpenDrawer) {
      onGetHistoryList();
    }
  }, [isOpenDrawer]);

  const onOpenDrawer = () => {
    setIsOpenDrawer(true);
  };

  const onCloseDrawer = () => {
    setIsOpenDrawer(false);
  };

  return (
    <>
      <IconButton aria-label="delete" onClick={onOpenDrawer}>
        <ClockIcon />
      </IconButton>

      <Drawer
        anchor={"right"}
        open={isOpenDrawer}
        onClose={onCloseDrawer}
        ModalProps={{
          keepMounted: false,
          sx: { zIndex: 2000000 },
        }}
        PaperProps={{
          className: "drawer-paper-wrapper",
        }}
      >
        <Box className="header-wrapper">
          <Typography variant="h6" fontWeight={800}>
            تاریخچه بروزرسانی
          </Typography>

          <IconButton
            size="small"
            onClick={onCloseDrawer}
            sx={{
              display: {
                xs: "inline-flex",
                lg: "none",
              },
            }}
          >
            <CloseIcon className="close-icon" />
          </IconButton>
        </Box>

        <Box className="content-wrapper">
          {loading || historyList.length === 0 ? (
            <Box
              sx={{
                minHeight: "50vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {loading ? (
                <LoadingWrapper />
              ) : (
                <Typography variant="body2" fontWeight={600}>
                  اطلاعاتی یافت نشد
                </Typography>
              )}
            </Box>
          ) : (
            <Grid container>
              {historyList.map((history) => (
                <HistoryItem history={history} key={history.id} />
              ))}
            </Grid>
          )}
        </Box>
      </Drawer>
    </>
  );
};

export default HistoryDrawer;
